<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		fill="currentColor"
		viewBox="0 0 52 52"
		data-name="Layer 1"
		xmlns="http://www.w3.org/2000/svg"
		><path
			d="M24.56,45.75A1.45,1.45,0,0,0,26,44.3l.08-16.77A1.5,1.5,0,0,0,24.81,26H7.72a1.49,1.49,0,0,0-1.53,1.29v3.3a1.49,1.49,0,0,0,1.29,1.53H13a1.08,1.08,0,0,1,1.05,1.05,1.1,1.1,0,0,1-.25.73L2.56,45.18a1.65,1.65,0,0,0-.08,2.26l2.18,2.17a1.7,1.7,0,0,0,2.25-.08L18.28,38.17a1,1,0,0,1,1.45,0,.75.75,0,0,1,.24.73v5.31a1.51,1.51,0,0,0,1.29,1.54h3.3Z"
		></path><path
			d="M30.53,48.33A24,24,0,0,0,43.1,41.88a23.37,23.37,0,1,0-33-33.05A23.09,23.09,0,0,0,3.61,21.32H8.36A18.65,18.65,0,0,1,39.8,12.14a18.66,18.66,0,0,1-9.11,31.43Zm.24-9.6a13.14,13.14,0,0,0,5.72-3.46A14,14,0,0,0,16.67,15.44a13.86,13.86,0,0,0-3.47,5.8h5A9.21,9.21,0,0,1,20,18.66,9.35,9.35,0,0,1,33.19,31.88a10.49,10.49,0,0,1-2.42,1.78Z"
		></path></svg
	>
</div>
